'use client';

import { useEffect, useState } from 'react';

import { motion } from 'framer-motion';

import { cn } from '@/lib/utils';

interface MagicalTextProps {
  children: string;
  className?: string;
}

export const MagicalText = ({ children, className }: MagicalTextProps) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return <span className={className}>{children}</span>;
  }

  return (
    <span className={cn('relative inline-block', className)}>
      <motion.span
        className="magical-gradient-text relative inline-block"
        animate={{
          backgroundPosition: ['0% 50%', '100% 50%', '0% 50%'],
        }}
        transition={{
          duration: 8,
          repeat: Infinity,
          ease: 'linear',
        }}
        style={{
          background:
            'linear-gradient(90deg, currentColor 0%, currentColor 30%, rgba(147, 197, 253, 0.9) 40%, rgba(196, 181, 253, 0.9) 50%, rgba(147, 197, 253, 0.9) 60%, currentColor 70%, currentColor 100%)',
          backgroundSize: '200% auto',
          backgroundClip: 'text',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
        }}
      >
        {children}
      </motion.span>
    </span>
  );
};
